import React, { FC } from 'react';
import moment from 'moment';

import { IProtection } from '../../../../models/types';
import getFullName from '../../../../utils/getFullName';

import Table from '../../../../components_/Table';
import TableColLink from '../../../../components_/Table/TableColLink';
import TableColText from '../../../../components_/Table/TableColText';
import TableActionGroup from '../../../../components_/Table/TableActionGroup';
import { EditOutlined, CopyOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import Icon from '../../../../components_/Icon';

export interface IProps {
  onClickEdit: any;
  onClickCopy: any;
  onClickUnbind: any;
  onClickDelete: any;
  list: IProtection[];
}

const List: FC<IProps> = ({ list, onClickEdit, onClickCopy, onClickUnbind, onClickDelete }) => {
  const rows = list.map(item => ({
    items: {
      number: (
        <TableColText onClick={onClickEdit(item)}>
          <TableColLink>{item.number}</TableColLink>
        </TableColText>
      ),
      className: <TableColText>{item.className}</TableColText>,
      numberType: <TableColText>{item.numberType}</TableColText>,
      mappingType: (
        <TableColText>
          {item.mappingType === 'USER_PERMANENT' ? 'Постоянный' : 'Временный'}
        </TableColText>
      ),
      fio: <TableColText>{getFullName(item.fio)}</TableColText>,
      bestBefore: (
        <TableColText>
          {item.bestBefore && moment(item.bestBefore).format('DD.MM.YYYY')}
        </TableColText>
      ),
      actions: (
        <TableActionGroup>
          <Tooltip placement="top" title="Редактировать">
            <Button type={'text'} onClick={onClickEdit(item)} icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip placement="top" title="Копировать">
            <Button type={'text'} onClick={onClickCopy(item)} icon={<CopyOutlined />} />
          </Tooltip>
          <Tooltip placement="top" title="Открепить">
            <Button
              type={'text'}
              onClick={onClickUnbind(item)}
              disabled={!Boolean(item.fio)}
              icon={<Icon name="unlink" size="s" />}
            />
          </Tooltip>
          <Tooltip placement="top" title="Удалить">
            <Button type={'text'} danger onClick={onClickDelete(item)} icon={<DeleteOutlined />} />
          </Tooltip>
        </TableActionGroup>
      )
    }
  }));

  const cols = [
    {
      title: 'Метка',
      field: 'number'
    },
    {
      title: 'Тип',
      field: 'className'
    },
    {
      title: 'Технология',
      field: 'numberType'
    },
    {
      title: 'Тип использования',
      field: 'mappingType'
    },
    {
      title: 'Владелец',
      field: 'fio'
    },
    {
      title: 'Срок эксплуатации до',
      field: 'bestBefore'
    },
    {
      title: '',
      field: 'actions'
    }
  ];

  return <Table cols={cols} rows={rows} />;
};

export default List;
